import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImageChatMessageService } from '@examdojo/chat';
import { assertNonNullable } from '@examdojo/core/util/assert';
import { isNotNullish } from '@examdojo/core/util/nullish';
import { QuestionEntityQuery } from '@examdojo/question';
import { ReviewItemHttpService } from '@examdojo/review';
import { UserQuery } from '@examdojo/user';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs';

@Injectable()
export class QuestionEditorImageChatEffectService {
  constructor(
    private readonly imageChatMessageService: ImageChatMessageService,
    private readonly questionEntityQuery: QuestionEntityQuery,
    private readonly reviewItemHttpService: ReviewItemHttpService,
    private readonly userQuery: UserQuery,
  ) {
    this.fetchQuestionImageChats().pipe(takeUntilDestroyed()).subscribe();
  }

  private fetchQuestionImageChats() {
    return this.questionEntityQuery.selectActiveId().pipe(
      filter(isNotNullish),
      distinctUntilChanged(),
      switchMap((questionId) => {
        const userId = this.userQuery.getActiveId();
        assertNonNullable(userId, 'User ID not found');

        return this.reviewItemHttpService.fetchByQuestionId(questionId).pipe(
          map((reviewItems) => reviewItems[0]),
          filter(isNotNullish),
          switchMap((reviewItem) => this.imageChatMessageService.fetchReviewImageChats(reviewItem.id, userId)),
        );
      }),
    );
  }
}
